// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21hCU","toggleWrap":"styles_toggleWrap__3ePNz","content":"styles_content__1QOAo","selectAreaCode":"styles_selectAreaCode__1htoU"};